import React, { useMemo } from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { cn } from '../lib/utils';

type ScribaneAvatarProps = {
  className?: string;
};

export const ScribaneAvatar: React.FC<ScribaneAvatarProps> = ({ className }) => {
  const { t } = useLocale();
  const logoUrl = useMemo(
    () =>
      new URL(
        '../assets/logos/SVG/POSITIVO/logo scribane_positivo micro simple adjusted.svg',
        import.meta.url
      ).href,
    []
  );

  return (
    <div
      className={cn(
        'h-8 w-8 rounded-full overflow-hidden flex items-center justify-center bg-background border border-border',
        className
      )}
    >
      <img src={logoUrl} alt={t('scribane')} className="h-6 w-6 object-contain" />
    </div>
  );
};
